import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Icon } from '../Icon';
export var StyledIcon = styled(Icon)(_templateObject(), function (props) {
  return "\n        ".concat(props.disabled ? "\n            color: ".concat(props.theme.global.colors.porcelainDarker, ";\n            cursor: not-allowed !important;\n        ") : '', "\n    ");
});